// https://github.com/directus/monospace/blob/main/app/src/utils/format-filesize.ts
export function formatFilesize(bytes = 0, decimal = true): string {
	const threshold = decimal ? 1000 : 1024;

	if (Boolean(bytes) === false) {
		return '--';
	}

	if (Math.abs(bytes) < threshold) {
		return `${bytes} B`;
	}

	const units = decimal
		? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
		: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

	let unitIndex = -1;
	let remainingBytes = bytes;

	do {
		remainingBytes /= threshold;
		unitIndex += 1;
	} while (Math.abs(remainingBytes) >= threshold && unitIndex < units.length - 1);

	// Round to one decimal, dropping a redundant trailing ".0" so whole values
	// read "5 MB" while "5.2 MB" stays.
	return `${Number(remainingBytes.toFixed(1))} ${units[unitIndex]}`;
}
